import React from 'react';

import { withAuthLayout } from '@/layouts/Auth';

import { Spinner } from '@bypasslane/clover--web-lib-sprout-spinner';
import PropTypes from 'prop-types';

export const LoadingSpinner = ({ title = '' }) => {
  return (
    <div className="text-center py-5">
      <div className="flex justify-center items-center mb-4">
        <Spinner ariaLabel="loading" spinnerSize="large" spinnerVariant="greenSpinner" />
      </div>
      {title && <p className="mt-4 text-lg font-medium text-gray-700">{title}</p>}
    </div>
  );
};

LoadingSpinner.propTypes = {
  title: PropTypes.string
};
LoadingSpinner.displayName = 'LoadingSpinner';

export default withAuthLayout(LoadingSpinner, {
  enaableErrorBoundary: true
});
